import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Numbers } from '@constants/numbers';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ErrorConfig } from "@models/error-config";

@Injectable({
  providedIn: 'root',
})
export class ApiHelperService {
  private headers: HttpHeaders = new HttpHeaders();
  private errorSubject = new Subject<any>();
  private readonly defatulErrorConfig: ErrorConfig = { showAlert: true, errorMessage: null };

  constructor(private http: HttpClient) {}

  errorHandler(errorObj: any, errorConfig: ErrorConfig) {
    const statusCode = errorObj.status ?? null;
    if (errorConfig?.showAlert || statusCode === 401) {
      errorObj['customMessage'] = errorConfig?.errorMessage;
      this.showErrorAlert(errorObj);
    }
    return this.catchError(errorObj);
  }

  complete<TResponse>(responseJson: any) {
    return responseJson;
  }

  completeDummy<TResponse>(responseJson: any, endPoint: string) {
    return responseJson[endPoint];
  }

  public getJSON(): Observable<any> {
    return this.http.get('./assets/mydata.json');
  }

  // Método para mostrar alertas de error
  public showErrorAlert(error: any) {
    this.errorSubject.next(error);
  }

  getErrorSubject() {
    return this.errorSubject.asObservable();
  }

  // Método GET
  public apiGet<TResponse>(endPoint: string, errorConfig: ErrorConfig = this.defatulErrorConfig): Observable<TResponse> {
    return this.getJSON().pipe(
      map((responseJson) => this.completeDummy<TResponse>(responseJson, endPoint)),
      retry(Numbers._1),
      catchError((error) => {
        return this.errorHandler(error, errorConfig);
      })
    );
  }

  // Método GET
  public get<T>(endpoint: string, errorConfig: ErrorConfig = this.defatulErrorConfig): Observable<T> {
    return this.http.get(`${endpoint}`).pipe(
      map(this.mapResponse),
      catchError((error) => {
        return this.errorHandler(error, errorConfig);
      })
    );
  }

  // Método DELETE
  public delete<T>(
    endpoint: string, config?: {}, errorConfig: ErrorConfig = this.defatulErrorConfig
  ): Observable<T> {
    return this.http.delete(`${endpoint}`, config).pipe(
      map(this.mapResponse),
      catchError((error) => {
        return this.errorHandler(error, errorConfig);
      })
    );
  }

  // Método POST
  public post<E, T = E>(
    endpoint: string, data?: E, config?: {}, errorConfig: ErrorConfig = this.defatulErrorConfig
  ): Observable<T> {
    return this.http.post<T>(`${endpoint}`, data, config).pipe(
      map(this.mapResponse),
      catchError((error) => {
        return this.errorHandler(error, errorConfig);
      })
    );
  }

  // Método PUT
  public put<E, T = E>(
    endpoint: string, data?: E, config?: {}, errorConfig: ErrorConfig = this.defatulErrorConfig
  ): Observable<T> {
    return this.http.put<T>(`${endpoint}`, data, config).pipe(
      map(this.mapResponse),
      catchError((error) => {
        this.showErrorAlert(error);
        return this.errorHandler(error, errorConfig);
      })
    );
  }

  mapResponse = (response: any) => response;
  catchError = (error: any) => throwError(() => error);

  // Método PATCH
  public patch<T>(endpoint: string, data?: any, errorConfig: ErrorConfig = this.defatulErrorConfig): Observable<T> {
    return this.http.patch<T>(`${endpoint}`, data, { headers: this.headers }).pipe(
      map(this.mapResponse),
      catchError((error) => {
        return this.errorHandler(error, errorConfig);
      })
    );
  }
}
